import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { memo, useCallback } from "react";
import "./DashboardCard.css";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";

type Props = {
  title: string;
  icon: IconDefinition;
  link: string;
};

export const DashboardCard = memo(({ title, icon, link }: Props) => {

  const navigate = useNavigate();
  const location = useLocation();
  const match = location.pathname.startsWith(link);

  const handleNavigateClick = useCallback(() => {
    navigate(link);
  }, [navigate, link]);

  return (
    <Card className={classNames("dashboard-card", { active: match })} onClick={handleNavigateClick}>
      <Card.Body className="d-flex flex-column align-items-center justify-content-center py-4 gap-2">
        <FontAwesomeIcon className="dashboard-card-icon" icon={icon} size="2x" />
        <span className="dashboard-card-title">{title}</span>
      </Card.Body>
    </Card>
  );
});
